import React from 'react';
import ModuleImagePage from '../shared/ModuleImagePage.jsx';

const Inventory = () => <ModuleImagePage moduleKey="inventory" />;

export default Inventory;
